import { onError } from "@apollo/client/link/error";
import { addBreadcrumb, captureException, type SeverityLevel } from "@sentry/react";

import { unauthorizedErrorRedirect } from "@helpers/unauthorizedErrorRedirect/unauthorizedErrorRedirect";
import type { ErrorNotice } from "@shared/context/ErrorNotifierContext";
import { turnOffErrorReporting } from "@shared/utils/initSentry/filters/turnErrorsOff/turnErrorsOff";

const getErrorLink = (
  notify?: (notice: ErrorNotice) => void,
  disableUnauthorizedCheck?: boolean
) => {
  return onError(({ graphQLErrors, networkError, response, operation }) => {
    addBreadcrumb({
      category: "apolloOnError",
      data: {
        operationName: operation.operationName,
        networkError,
        response: JSON.stringify(response),
        graphQLErrors: JSON.stringify(graphQLErrors),
      },
      level: "info" as SeverityLevel,
    });

    const statusCode = networkError && "statusCode" in networkError && networkError.statusCode;
    const isEmancipatedDependent = graphQLErrors?.[0]?.extensions?.code === "EMANCIPATED_DEPENDENT";

    if (!!statusCode && statusCode !== 403) {
      captureException(networkError, { level: "warning" });
    }

    if (networkError) {
      turnOffErrorReporting();
    }

    if (statusCode === 403 && isEmancipatedDependent) {
      window.location.replace("/accounts");
    }

    if (graphQLErrors && notify) {
      graphQLErrors.forEach(error => notify({ error }));
    }

    if (!disableUnauthorizedCheck) {
      unauthorizedErrorRedirect(networkError);
    }
  });
};

export { getErrorLink };
